import ProductQuality from "modules/product_quality/ProductQuality";
import OrgQuality from "modules/product_quality/OrgQuality";
import ProductSEO from "modules/product_quality/ProductSEO";
import ContentTemplate from "./ContentTemplate";
import type { RouteDefinition } from "../../routes/routes";

export const QualityRoutes: RouteDefinition[] = [
  {
    path: "/content/quality/product",
    layout: "/user",
    component: ProductQuality,
    application: "Product",
  },
  {
    path: "/content/quality/org",
    layout: "/user",
    component: OrgQuality,
    application: "Product",
  },
  {
    path: "/content/quality/category/:category",
    layout: "/user",
    component: OrgQuality,
    application: "Product",
  },
  {
    path: "/content/seo",
    layout: "/user",
    component: ProductSEO,
    application: "Product",
  },
  {
    path: "/content/templates/:templateId",
    layout: "/user",
    component: ContentTemplate,
    application: "Product",
  },
];
